import { Box } from "@mui/material"
import { useLocation } from "react-router-dom"
import { fade } from "../motion"

/**
 * The fade between pages.
 *
 * Keyed on the first path segment, not the whole path — that is the whole
 * subtlety here. Keying on `location.pathname` would remount the page component
 * on every URL change, which means `/chat` → `/chat/5` throws away the loaded
 * inbox and refetches it to open a thread that is already on screen. The first
 * segment changes exactly when the page does.
 *
 * A fade and nothing else. The rows and cards inside do the rising, and a page
 * that slides while its own contents are also sliding reads as two things moving
 * past each other.
 */
export default function PageTransition({ children }) {
  const { pathname } = useLocation()
  const segment = pathname.split("/")[1] || "home"

  return (
    <Box key={segment} sx={fade()}>
      {children}
    </Box>
  )
}
